module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "dm03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  })])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "Images/dm.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("The hall is large, and the density on the dance floor is inhuman. The deejay has the music of Hakim cranked up so loudly that the plate-glass picture windows are trembling. The guests chant along with the lyrics: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fire, Fire, Fire! My heart’s stoked by fire!")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Karima spots us almost immediately, and rushes over in a paroxysm of hospitable gushing. Having gotten lost, we’re obscenely late, but she tells us that the couple has only just arrived. Huda and her groom are installed on the massive wicker chairs that serve as the room’s focal point. Gargantuan floral tableaus are positioned as backdrops to the couple, and someone has spray-painted a banner that reads "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HUDA AND EHAB")]), _vm._v(" in cheerful pink and purple script.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And there is Huda, sitting stiffly, swathed in a bright white gown that drips shiny beads and tulle. Her raven hair, exposed for the occasion, is gathered high on her head, a few sidelocks shellacked into place at curiously curled angles. Her makeup is heavy, yet no amount of rouge could give color to her pale, distracted features.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her plump arm is a treasure map drawn in henna; clutching it is her groom. He is shorter than Huda and slumped in his chair. His stomach droops over his belt. His ears jut out at near-right angles to a head that is crowned by a slick, three-hair comb-over. Beady eyes stare unblinking from beneath too thin eyebrows, and his mouth twists in an awkward, anticipatory grin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Karima is leading us to the newlyweds, and we understand it to be a sort of receiving line. She pushes us ahead of the line of people.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("Huda smiles when she sees us, and it looks as though her mascara-encrusted eyes are in danger of brimming over. She ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("shouts so I can hear her: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I’m so happy you came")]), _vm._v(". She kisses my cheeks extra hard. She insists that we join the dancing, and a girl that she refers to as her maternal aunt’s daughter appears to guide us into the mêlée.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Meg and I start to protest, but the nameless cousin grabs our hands and forces us into movement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I am overwhelmed. I am the most discomfited of dancers. Simultaneously, chillingly, I am certain that the wedding guests sense it to be a sad occasion, yet all are in desperate conspiracy to produce a joyful atmosphere. They dance madly. As though…as though if they were to stop, and cast a thoughtful eye on the bride and groom, the illusion would be dispelled. The party dresses and hairspray and starched collars and lipsticked lips would melt away, and all present would be left standing in the rags of Huda’s despair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But soon Huda herself arises from the throne and descends the two steps to the dance floor. Her husband claps his hands lamely as she dances without looking at him. The circle expands to make her its center, and Ehab shifts from foot to foot self-consciously.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But no one is looking at him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("All eyes are fixed on Huda, who, weaving herself into the now meditative rhythms of the music, is transformed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Huda’s eyes are downcast, one hand on her hip, another arcing in the air as it parallels the smooth, circular motion of her wide hips. I am surprised that such a seemingly bulky woman can move with such fluidity. The beads on her dress tremble and swing with her movements. She is untouchable for a moment, moving transcendence, a manifestation of the music’s seductive nuances.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The spell is broken by a tooth-jarring ululation from Karima, and the gentler music submits to the wailings of "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/c.jpg"
    }
  }), _vm._v("Amr Diyab.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Huda looks up, and I see reality invade her gaze.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Other women in the group, aunts, friends, sisters-in-law, take up the ululations. The sound swells, and Huda, forcing a smile, pulls her mother into the circle with her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They dance, eyes locked, for only a moment. Others join them, and the clapping intensifies with the pounding of the synthesized drums.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Meg and I join the dance, but we cannot prolong the effort for very long.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We slip away early for drinks at the Marriott. We are silent, willingly surrendering the conversation to fellow students who have met us there. We are incapable of allaying the feeling that we have just witnessed the inflicting of a perhaps fatal wound, and we, along with all present, are guilty of dancing on a blood-slicked floor. Once in a while, Meg’s eyes meet mine, but we can only share wordless frowns.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We drink in Huda’s honor.")])])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page29"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a72ae482","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780765316578_dm03.vue
// module id = 81
// module chunks = 0